module.exports = __webpack_public_path__ + "img/close.639b3799.svg";